import * as React from 'react';
import {Backdrop, CircularProgress, Divider,Accordion,AccordionSummary,Typography,AccordionDetails} from '@mui/material';
import {Delete, Edit,ExpandMore} from '@mui/icons-material';
import {useTranslation} from "react-i18next";
import {convertPrice, handleSetServicesLogo} from "../../assets/js/main";
import {useDispatch, useSelector} from "react-redux";
import {ThemeContext} from "../../App";


export default function Review(props) {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const selector = useSelector((st) => st)
  const [expanded, setExpanded] = React.useState(null);


  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  }

  const handlerSplitDate = (e) => {
    return e?.split("|")
  }

  const handlerPaymentType = (e) => {
    switch (e){
      case 'online':
        return `${t("singleOrder.packageInfo.t14")}`;
      case 'cod':
        return `${t("singleOrder.packageInfo.t15")}`;
      case 'amnito':
        return `${t("singleOrder.packageInfo.t16")}`;
      case 'free':
        return `${t("singleOrder.packageInfo.t17")}`;
      case 'pass':
        return `${t("singleOrder.packageInfo.t18")}`;
    }
  }




  return (
     <>
       {/*<Backdrop*/}
       {/*   className="backdrop-loading"*/}
       {/*   open={selector?.loading?.isLoading}*/}
       {/*>*/}
       {/*  <div className="backdrop-bg">*/}
       {/*    <div className="loader" style={theme.darkMode ? {backgroundImage: "url('/splash2.gif')"} : {backgroundImage: "url('/splash1.gif')"}}/>*/}
       {/*  </div>*/}
       {/*</Backdrop>*/}
       {/*{selector?.loading?.isLoading &&*/}
       {/*<div className="backdrop-loading">*/}
       {/*  <div className="backdrop-bg">*/}
       {/*    <div className="loader" style={theme.darkMode ? {backgroundImage: "url('/splash2.gif')"} : {backgroundImage: "url('/splash1.gif')"}}/>*/}
       {/*  </div>*/}
       {/*</div>*/}
       {/*}*/}

       <div className="reviewPage">
         <div className="row">
           <div className="col-12">
             <div className="detailsBox">
               <h4 className="titleSection">{t("singleOrder.review.t1")}</h4>
               {
                 selector?.single_review?.listReview?.map((item, index) => {
                   return (
                      <Accordion key={index} expanded={expanded === index} onChange={handleChange(index)}>
                        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMore/>}>
                          <Typography>{t("singleOrder.review.t2")} {index + 1}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className="row">
                            <div className="col-6 col-md-4 col-lg-3">
                              <h6>{t("singleOrder.review.t3")}</h6>
                              <span>{item?.GoodsType || '-'}</span>
                            </div>
                            <div className="col-6 col-md-4 col-lg-3">
                              <h6>{t("singleOrder.review.t5")}</h6>
                              <span>{item?.ApproximateValue?.toLocaleString() || '-'} {t("singleOrder.review.t6")}</span>
                            </div>
                            <div className="col-6 col-md-4 col-lg-3">
                              <h6>{t("singleOrder.review.t7")}</h6>
                              <span>{item?.Weight?.toLocaleString() || '-'} {t("singleOrder.review.t8")}</span>
                            </div>
                            <div className="col-6 col-md-4 col-lg-3">
                              <h6>{t("singleOrder.review.t9")}</h6>
                              <span>{item?.CartonSizeName || '-'}</span>
                            </div>
                            {
                               item?.NeedCarton && <div className="col-6 col-lg-4">
                                 <h6>{t("singleOrder.review.t11")}</h6>
                                 <span>{item?.NeedCarton ? 'بله' : 'خیر'}</span>
                               </div>
                            }

                            <Divider/>
                            <div className="col-12">
                              <div className="_bodyPage">
                                <div className="row">
                                  <div className="col-12 col-lg-6">
                                    <h4 className="titleSection">{t("singleOrder.review.t12")}</h4>
                                    <div className="userInfo">
                                      <div className="userName">
                                        <h6>{(item?.Reciver_FristName || '-') + ' ' + (item?.Reciver_LastName || '-')}</h6>
                                      </div>
                                      <div className="phoneNumber">
                                        <h6>{item?.Reciver_mobile || '-'}</h6>
                                      </div>
                                    </div>
                                    <div className="location">
                                      <h6>{item?.Reciver_Address || '-'}</h6>
                                    </div>
                                    <Divider className="d-block d-lg-none"/>
                                  </div>
                                  <div className="col-12 col-lg-6">
                                    <div className="serviceType">
                                      <h4 className="titleSection">{t("singleOrder.review.t13")}</h4>
                                      <div className="service">
                                        <div className="infoService">
                                          <img src={handleSetServicesLogo(item?.SLA?.ServiceName)} alt=""/>
                                          <p>{item?.SLA?.ServiceName}</p>
                                        </div>
                                        <div className="timeService">
                                          <p>{t("singleOrder.review.t14")} : {handlerSplitDate(item?.SLA?.SLA)?.[0]}</p>
                                          <p> {t("singleOrder.review.t15")} : {convertPrice(item?.SLA?.Price)} {t("singleOrder.review.t6")} | {handlerPaymentType(item?.paymentType)}</p>
                                        </div>
                                      </div>
                                    </div>
                                    <Divider className="d-block d-lg-none"/>
                                  </div>
                                </div>
                                {/*<Divider/>*/}

                                {/*{*/}
                                {/*  props?.item?.shipmentsData?.length &&*/}
                                {/*  <>*/}
                                {/*    <div className="infoPrice">*/}
                                {/*      <div className="row">*/}
                                {/*        <div className="col-12 col-md-6 col-lg-4">*/}
                                {/*          <div className="price">*/}
                                {/*            <p>{t("singleOrder.review.t16")}</p>*/}
                                {/*            <p>45،122 {t("singleOrder.review.t6")}</p>*/}
                                {/*          </div>*/}
                                {/*        </div>*/}
                                {/*        <div className="col-12 col-md-6 col-lg-4">*/}
                                {/*          <div className="price">*/}
                                {/*            <p>{t("singleOrder.review.t17")}</p>*/}
                                {/*            <p>16،122 {t("singleOrder.review.t6")}</p>*/}
                                {/*          </div>*/}
                                {/*        </div>*/}
                                {/*        <div className="col-12 col-md-6 col-lg-4">*/}
                                {/*          <div className="price">*/}
                                {/*            <p>{t("singleOrder.review.t18")}</p>*/}
                                {/*            <p>16،122 {t("singleOrder.review.t6")}</p>*/}
                                {/*          </div>*/}
                                {/*        </div>*/}
                                {/*        <div className="col-12 col-md-6 col-lg-4">*/}
                                {/*          <div className="price">*/}
                                {/*            <p>{t("singleOrder.review.t19")}</p>*/}
                                {/*            <p>164،122 {t("singleOrder.review.t6")}</p>*/}
                                {/*          </div>*/}
                                {/*        </div>*/}
                                {/*        <div className="col-12 col-md-6 col-lg-4">*/}
                                {/*          <div className="price">*/}
                                {/*            <p>{t("singleOrder.review.t20")}</p>*/}
                                {/*            <p>164،122 {t("singleOrder.review.t6")}</p>*/}
                                {/*          </div>*/}
                                {/*        </div>*/}
                                {/*        <div className="col-12 col-md-6 col-lg-4">*/}
                                {/*          <div className="price">*/}
                                {/*            <p>{t("singleOrder.review.t21")}</p>*/}
                                {/*            <p>164،122 {t("singleOrder.review.t6")}</p>*/}
                                {/*          </div>*/}
                                {/*        </div>*/}
                                {/*      </div>*/}
                                {/*    </div>*/}
                                {/*  </>*/}
                                {/*}*/}

                              </div>
                            </div>

                            <div className="col-12">
                              <div className="action">
                                <button type="button"
                                        onClick={() => props.handlerDeleteFromListReview(index)} id="deleteFromListReview">
                                  <Delete/>
                                </button>
                                <button type="button"
                                        onClick={() => props.handlerEditItemListReview({
                                          index: index,
                                          ServiceID: item?.ServiceID
                                        })} id="editItemListReview">
                                  <Edit/>
                                </button>
                              </div>
                            </div>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                   )
                 })
               }
             </div>
           </div>
           <div className="col-12 col-md-6 col-lg-4 mb-2">
             <label>{t("singleOrder.invoice.t33")}</label>
             <input type="text" autoComplete="on"
                    value={props.discountCode} id="discountCode"
                    onChange={e => props.handleDiscountCode(e.target.value)}/>
           </div>
         </div>
       </div>
     </>
  )
}
